import Vue from 'vue'

import { BrowserType, signWH } from '@/utils'
import config from '@/config'

const basePath = { config }

//上传文件说明
Vue.directive('fa-file', {
  update: (el, binding, vnode) => {
    el.value = ''
  }
})
//光标显示
Vue.directive('input-focus', {
  bind: function(el, binding, vnode) {
    if (binding.value) {
      el.focus()
    }
  },
  update: function(el, binding, vnode) {
    if (binding.value) {
      el.focus()
    }
  }
})
//用户头像显示
Vue.directive('fa-logo', {
  bind: function(el, binding, vnode) {
    let url = `${basePath}/account/get-logo`
    el.style.background = `url(${url}) center/cover no-repeat`
  },
  update: function(el, binding, vnode) {
    let url = `${basePath}/account/get-logo?s=${binding.value}`
    el.style.background = `url(${url}) center/cover no-repeat`
  }
})
//企业头像显示
Vue.directive('fa-org-logo', {
  bind: function(el, binding, vnode) {
    let url = `${basePath}/newcoreorg/company/get-logo`
    el.style.background = `url(${url}) center/cover no-repeat`
  },
  update: function(el, binding, vnode) {
    let url = basePath + `/newcoreorg/company/get-logo`
    el.style.background = 'url(' + url + ') center/cover no-repeat'
  }
})

//存储印章图片
let info = ''
function drapInfo(e, binding) {
  if (!binding.value.isSignDrop) {
    return false
  }
  if (BrowserType().name == 'FF') {
    e.dataTransfer.setData('imgInfo', e.target.id)
  }
  if (binding.value.type > 6) {
    info = {
      signStyle: binding.value.signStyle,
      type: binding.value.type,
      img: binding.value.value
    }
  } else {
    info = {
      signStyle: binding.value.signStyle,
      type: binding.value.type,
      list: binding.value.value,
      index: binding.value.index
    }
  }
}
//印章盖章
Vue.directive('fa-sign-drap', {
  bind: (el, binding, vnode) => {
    el.ondragstart = e => {
      drapInfo(e, binding)
    }
  },
  update: (el, binding, vnode) => {
    el.ondragstart = e => {
      drapInfo(e, binding)
    }
  }
})
// 拖放印章数据处理
function dropMsg(el, binding) {
  let x = 0,
    y = 0,
    offert = null
  el.ondragover = e => {
    e.preventDefault()
    if (BrowserType().name === 'IE') {
      e.returnValue = false
    }
    if (e.target.offsetParent.className === 'template-edit-box') {
      x = parseFloat(e.target.offsetParent.style.left)
      y = parseFloat(e.target.offsetParent.style.top)
      offert = { left: x + e.offsetX, top: y + e.offsetY }
    } else if (e.target.offsetParent.className.indexOf('template-edit-con') > -1) {
      x = parseFloat(e.target.offsetParent.parentElement.style.left)
      y = parseFloat(e.target.offsetParent.parentElement.style.top)
      offert = { left: x + e.offsetX, top: y + e.offsetY }
    } else {
      x = 0
      y = 0
      offert = null
    }
    if (e.target.getAttribute('page') != null) {
      binding.value.pageNO = e.target.getAttribute('page')
    }
  }
  el.ondrop = e => {
    if (BrowserType().name == 'FF') {
      e.stopPropagation()
    }
    e.preventDefault()
    if (info) {
      let left = 0
      let height = signWH(info.type).height
      let width = signWH(info.type).width
      let scrollY = e.offsetY
      let scrollHeight = binding.value.heightList[0].h
      if (binding.value.pageNO > 0) {
        for (let i = 0; i < binding.value.heightList.length; i++) {
          if (binding.value.pageNO > binding.value.heightList[i].p) {
            scrollY += binding.value.heightList[i].h
            scrollHeight += binding.value.heightList[i].h
          }
        }
      }
      let dropUpInfo = {
        x: e.offsetX,
        y: scrollY - height / 2,
        pageNO: binding.value.pageNO,
        info: info
      }
      if (offert) {
        dropUpInfo = {
          x: offert.left,
          y: offert.top - height / 2,
          pageNO: binding.value.pageNO,
          info: info
        }
      }
      if (dropUpInfo.x < 0) {
        dropUpInfo.x = 0
      } else if (dropUpInfo.x + width > binding.value.heightList[binding.value.pageNO].w) {
        dropUpInfo.x = binding.value.heightList[binding.value.pageNO].w - width
      } else {
        let x = dropUpInfo.x - height / 2
        dropUpInfo.x = x < 0 ? 0 : x
      }

      if (dropUpInfo.y < 0) {
        dropUpInfo.y = 0
      } else if (dropUpInfo.y + width > scrollHeight) {
        dropUpInfo.y = scrollHeight - width
      }
      binding.value.drop(dropUpInfo)
    }
  }
  el.ondragend = e => {
    info = ''
    offert = null
    e.stopPropagation()
  }
}
//拖放印章
Vue.directive('fa-sign-drop', {
  bind: (el, binding, vnode) => {
    dropMsg(el, binding)
  },
  update: (el, binding, vnode) => {
    dropMsg(el, binding)
  }
})
//印章拖动
Vue.directive('fa-sign-mouse', {
  bind: (el, binding, vnode) => {
    let x = 0,
      y = 0,
      dragFlag = false,
      leftX = 0,
      topY = 0
    el.onmousedown = e => {
      e.stopPropagation()
      x = e.clientX - el.offsetLeft
      y = e.clientY - el.offsetTop
      dragFlag = true
      document.onmousemove = e => {
        //e.preventDefault();
        if (dragFlag) {
          el.style.left = e.clientX - x + 'px'
          el.style.top = e.clientY - y + 'px'
        }
      }
      document.onmouseup = e => {
        e.stopPropagation()
        dragFlag = false
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
//文本框事件fours
Vue.directive('fa-focus', {
  bind: (el, binding, vnode) => {
    el.onclick = e => {
      e.preventDefault()
      el.focus()
      el.select()
    }
  }
})
//下一项
let countIndex = 0
Vue.directive('fa-next-foucus', {
  bind: (el, binding, vnode) => {
    countIndex = 0
  },
  update: (el, binding, vnode) => {
    let data = binding.value
    el.onclick = e => {
      if (data[countIndex]) {
        setTimeout(() => {
          data[countIndex].isFocus = true
          countIndex++
        }, 10)
      } else {
        if (data.length > 0) {
          countIndex = 0
          for (let i = 0; i < data.length; i++) {
            data[i].isFocus = false
          }
          setTimeout(() => {
            data[countIndex].isFocus = true
            countIndex++
          }, 10)
        }
      }
    }
  }
})
//文件预览滚动
let isLock = false
Vue.directive('fa-sign-scroll', {
  update: (el, binding, vnode) => {
    el.onscroll = e => {
      if (isLock) {
        isLock = false
        return
      }
      let top = 0
      let no = 0
      for (let i = 0; i < binding.value.heightList.length; i++) {
        let imgInfoList = binding.value.heightList[i]
        top += imgInfoList.h
        if (el.scrollTop > top) {
          no++
        }
      }
      //let no = Math.floor(el.scrollTop / (binding.value.height-100));
      binding.value.scroll(no)
    }
    isLock = true
    if (binding.value.isClick) {
      el.scrollTop = (binding.value.pageNO + 1 - 1) * (el.scrollHeight / binding.value.size)
    }
  }
})
Vue.directive('fa-update-scroll', {
  update: (el, binding, vnode) => {
    isLock = true
    if (binding.value.pageNO === 0) {
      el.scrollTop = 0
    } else {
      el.scrollTop = binding.value.pageNO * ((el.scrollHeight - 563) / binding.value.size)
    }
  }
})
Vue.directive('fa-next-scroll', {
  update: (el, binding, vnode) => {
    if (binding.value.focus && !binding.oldValue.focus) {
      document.getElementsByClassName('signature-con-scrollbar')[0].scrollTop = binding.value.y
      el.focus()
    }
  }
})
function tipsSign(el, binding) {
  let text = binding.value
  let span = null
  //计算当前文字的实际宽度
  let getTextWidth = str => {
    var width = 0
    var html = document.createElement('span')
    html.innerText = str
    html.className = 'getTextWidth'
    document.querySelector('body').appendChild(html)
    width = document.querySelector('.getTextWidth').offsetWidth
    document.querySelector('.getTextWidth').remove()
    return width
  }
  //获取当前元素的宽度
  let getStyle = (obj, attr) => {
    return obj.currentStyle ? obj.currentStyle[attr] : getComputedStyle(obj, false)[attr]
  }
  let length = getTextWidth(text)
  let spanWidth = 0
  Vue.nextTick(() => {
    let width = getStyle(el, 'maxWidth') === 'none' ? getStyle(el, 'width') : getStyle(el, 'maxWidth')
    spanWidth = parseInt(width)
    if (length > spanWidth) {
      span = document.createElement('span')
      span.id = 'tips'
      span.className = 'com-show-tips add-pos-left'
      span.style = 'white-space: normal;'
      span.innerText = text
      el.appendChild(span)
    }
  })
  ;(el.onmousemove = () => {
    if (length > spanWidth) {
      span.style.display = 'block'
    }
  }),
    (el.onmouseout = () => {
      if (length > spanWidth) {
        span.style.display = 'none'
      }
    })
}
//印章tips文案显示
Vue.directive('fa-tips-sign', {
  bind: (el, binding, vnode) => {
    tipsSign(el, binding)
  },
  update: (el, binding, vnode) => {
    tipsSign(el, binding)
  }
})
//禁止选中拖拽
Vue.directive('fa-no-drap', {
  bind: (el, binding, vnode) => {
    ;(el.ondragstart = () => {
      return false
    }),
      (el.oncontextmenu = () => {
        return false
      }),
      (el.onselectstart = () => {
        return false
      })
  }
})
//图片是否显示底图
Vue.directive('fa-img', {
  bind: (el, binding, vnode) => {
    let img = new Image()

    img.src = binding.value.url + '&ts=' + +new Date()
    img.onerror = () => {
      el.className = 'sign-icon-seal'
      el.style = 'font-size:100px;margin:26px auto'
      binding.value.bindError(false)
    }
  }
})
//附件图标显示
const pdf = require('@img/userCenter/pdf.png')
const excel = require('@img/userCenter/excel.png')
const jpg = require('@img/userCenter/jpg.png')
const wps = require('@img/userCenter/wps.png')
Vue.directive('fa-suffix-img', {
  bind: (el, binding, vnode) => {
    if (binding.value === '.pdf') {
      el.src = pdf
    } else if (binding.value === '.xlsx' || binding.value === '.xls') {
      el.src = excel
    } else if (binding.value === '.png' || binding.value === '.jpg' || binding.value === '.jpeg') {
      el.src = jpg
    } else if (binding.value === '.docx' || binding.value === '.doc') {
      el.src = wps
    }
  },
  update: (el, binding, vnode) => {
    if (binding.value === '.pdf') {
      el.src = pdf
    } else if (binding.value === '.xlsx' || binding.value === '.xls') {
      el.src = excel
    } else if (binding.value === '.png' || binding.value === '.jpg' || binding.value === '.jpeg') {
      el.src = jpg
    } else if (binding.value === '.docx' || binding.value === '.doc') {
      el.src = wps
    }
  }
})
